import React, {Component, useState} from "react"
import {connect} from 'react-redux';

import Layout from "../../../components/Layout"
import FilterReportsFinancial from "../../../components/FilterReports/financial"
import leng from "../../../data"
import Iframe from 'react-iframe'

import {
    DataTableSkeleton,
    Modal,
    StructuredListWrapper,
    StructuredListHead,
    StructuredListRow,
    StructuredListCell,
    StructuredListBody,
    TextArea,
} from "carbon-components-react"
import "./index.scss"

import {
    files_action_count,
    files_action_fetch
} from '../../../store/actions/files';
import TableGrid from "../../../components/TableReactGrid";

import {Xls20, DocumentWordProcessor20, ResetAlt20, Download20, Chat20} from "@carbon/icons-react";
import axios from "axios";
import {reports_financial_action_fetch, reports_financial_mongo_action_fetch} from "../../../store/actions/reports";
import moment from "moment";

const headers = [
    {name: "itens", title: <strong>Itens</strong>},
    {name: "worksheet", title: <strong>Worksheet</strong>},
    {name: "document", title: <strong>Document</strong>},

];


const rowsTable = [
    {
        "id": "1",
        "itens": "9 - Caixa e equivalentes de caixa",


    },
    {
        "id": "2",
        "itens": "10 - Contas a receber de clientes e outros recebíveis",

    },
    {
        "id": "3",
        "itens": "11 - Estoques",

    },
    {
        "id": "4",
        "itens": "12 - Ativo Fiscal",

    }
];

const tableColumnExtensions = [
    {columnName: 'worksheet', width: 150, align: "center"},
    {columnName: 'document', width: 150, align: "center"},
];


class Report extends Component {

    state = {
        isOpenModal:true
    };


    componentDidMount() {
        //     this.props.countFiles();
        //    this.props.fetchData({error: false,skip: 0});
    }

    render() {

        return (
            <Layout>
                <Modal
                    modalHeading="Ativo Fiscal"
                    open={this.state.isOpenModal}
                    onRequestClose={e => this.setState({isOpenModal: false})}
                    primaryButtonText="Confirm"
                    secondaryButtonText="Cancel"
                    size='lg'
                >
                        <span>

                            <StructuredListWrapper ariaLabel="Structured list">
                                <StructuredListHead>
                                    <StructuredListRow
                                        head
                                        tabIndex={0}
                                    >
                                      <StructuredListCell head>

                                      </StructuredListCell>
                                      <StructuredListCell head>
                                        2019
                                      </StructuredListCell>
                                      <StructuredListCell head>
                                        2018
                                      </StructuredListCell>
                                    </StructuredListRow>
                                  </StructuredListHead>
                                <StructuredListBody>
                                    <StructuredListRow tabIndex={0}>
                                      <StructuredListCell>
                                        Contribuição social - CSLL
                                      </StructuredListCell>
                                      <StructuredListCell>
                                        2.0
                                      </StructuredListCell>
                                      <StructuredListCell>
                                          2
                                      </StructuredListCell>
                                    </StructuredListRow>
                                    <StructuredListRow tabIndex={0}>
                                      <StructuredListCell>
                                      Imposto sobre produtos industrializados - IPI
                                      </StructuredListCell>
                                      <StructuredListCell>
                                        1.5
                                      </StructuredListCell>
                                      <StructuredListCell>
                                        1
                                      </StructuredListCell>
                                    </StructuredListRow>
                                    <StructuredListRow tabIndex={0}>
                                      <StructuredListCell>

                                      </StructuredListCell>
                                      <StructuredListCell>
                                        <strong>2.5</strong>
                                      </StructuredListCell>
                                      <StructuredListCell>
                                        <strong>3</strong>
                                      </StructuredListCell>
                                    </StructuredListRow>
                                  </StructuredListBody>
                            </StructuredListWrapper>
                             <div style={{marginBottom: '2rem'}}>
                              <TextArea
                                  cols={80}
                                  helperText="Optional helper text here; if message is more than one line text should wrap (~100 character count maximum)"
                                  id="test5"
                                  invalidText="Invalid error message."
                                  labelText="Observações"
                                  placeholder=""
                                  rows={4}
                              />
                              </div>
                        </span>

                </Modal>
                <div className="section">
                    <div className="section-heading">
                        <br/>
                        <p>{leng.sideBar.intelligentJourney.title}</p>
                        <h1>{leng.sideBar.intelligentJourney.links[4]}</h1>
                        <br/>
                    </div>
                </div>
                <div className="section-light">
                    <div className="section-light-heading">
                        <div className="file-upload-container">
                            <div className="MuiPaper-root div-header-border"
                                 style={{minHeight: "100px", backgroundColor: "#FFF", marginTop: "50px"}}>
                                <div style={{
                                    paddingTop: "16px",
                                    paddingLeft: "26px",
                                    fontSize: "20px",
                                    color: "#161616"
                                }}>All subcategories (146)
                                </div>
                                <div style={{
                                    paddingLeft: "26px",
                                    fontSize: "12px",
                                    paddingBottom: "16px",
                                    paddingTop: "8px",
                                    color: "#161616"
                                }}>May 2020 / Jun 2020
                                </div>
                                <div className="col-12 row flex-row-reverse"
                                     style={{paddingTop: "30px", paddingBottom: "10px"}}>
                                    <div style={{width: "40px", textAlign: "center"}}>
                                        <a
                                            href="https://domrock365-my.sharepoint.com/:w:/g/personal/jefferson_domrock_ai/Efmka4P0z0VHngPPHtp6sqYBa3iDnyniE_h5TKpHCHFNEA?e=klOzNf"
                                            target="_blank"><ResetAlt20/></a>
                                    </div>
                                    <div style={{width: "40px", textAlign: "center"}}>
                                        <a
                                            href="https://domrock365-my.sharepoint.com/:x:/g/personal/jefferson_domrock_ai/EX3jbf11MdFAsGpI-qQS_pUBu8bYtltCfKoAdkq8fx9Vbg?e=Xe0cHw"
                                            target="_blank"><Download20/></a>
                                    </div>
                                    <div style={{width: "40px", textAlign: "center"}}>
                                        <a
                                            href="https://domrock365-my.sharepoint.com/:x:/g/personal/jefferson_domrock_ai/EX3jbf11MdFAsGpI-qQS_pUBu8bYtltCfKoAdkq8fx9Vbg?e=Xe0cHw"
                                            target="_blank"><Chat20/></a>
                                    </div>
                                </div>
                            </div>
                            <TableGrid rows={rowsTable} headers={headers}
                                       tableColumnExtensions={tableColumnExtensions}/>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }
}

const
    mapStateToProps = ({reports}) => reports;

const
    mapDispatchToProps = dispatch => ({
        fetchData: params => dispatch(reports_financial_action_fetch(params)),
        fetchDataSearch: params => dispatch(reports_financial_mongo_action_fetch(params)),
    });

;

export default connect(
    mapStateToProps,
    mapDispatchToProps)(Report);
